document.documentElement.classList.add('js');
document.querySelectorAll('[data-language-select]').forEach(select => {
  const region=select.querySelector('[data-region-options]');if(region)region.hidden=false;
  select.addEventListener('change', () => { if(select.selectedOptions[0]?.hasAttribute('data-regional-option'))location.assign(select.value);else select.form.requestSubmit(); });
});
document.addEventListener('keydown', event => {
  if (event.key === 'Escape') document.querySelectorAll('.mobile-menu[open]').forEach(menu => {
    menu.open = false;
    menu.querySelector('summary').focus();
  });
});
document.querySelectorAll('.mobile-menu a').forEach(link => link.addEventListener('click', () => {
  link.closest('details').open = false;
}));

// Keep a wood or dish selected on the homepage open on the combined book page.
function openLinkedRecipe() {
  if (!location.hash.startsWith('#sample-')) return;
  const sample = document.getElementById(location.hash.slice(1));
  if (sample?.matches('details.book-sample')) sample.open = true;
}
openLinkedRecipe();
window.addEventListener('hashchange', openLinkedRecipe);
